import { type FC } from 'react'

import { useExperimentsContext } from '../../../experiments/components/ExperimentsContext'
import { experimentAccessorIsAdServerEnabled } from '../../../experiments/model/experimentAccessor'
import { AD_BANNER_AUTO_REFRESH_IDS } from '../../adServerConst'

import {
  type AdBannerProps,
  AdServerBannerContent,
} from './AdServerBannerContent'

export const AdServerBanner: FC<AdBannerProps> = (props) => {
  const { experiments } = useExperimentsContext()
  const isAdServerEnabled = experimentAccessorIsAdServerEnabled(experiments)

  if (!isAdServerEnabled) {
    return null
  }

  const { bannerTags } = props
  const isCarousel = bannerTags.some((tag) =>
    AD_BANNER_AUTO_REFRESH_IDS.includes(tag),
  )

  return <AdServerBannerContent {...props} isCarousel={isCarousel} />
}
